import React from 'react';
import styles from './NotificationFilters.module.css';

export type FilterValue = 'all' | 'unread' | 'order' | 'payment' | 'delivery' | 'promotion' | 'system';

interface FilterOption {
  label: string;
  value: FilterValue;
}

const FILTER_OPTIONS: FilterOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Unread', value: 'unread' },
  { label: 'Orders', value: 'order' },
  { label: 'Payments', value: 'payment' },
  { label: 'Deliveries', value: 'delivery' },
  { label: 'Promotions', value: 'promotion' },
];

interface NotificationFiltersProps {
  activeFilter: FilterValue;
  onFilterChange: (filter: FilterValue) => void;
}

export const NotificationFilters: React.FC<NotificationFiltersProps> = ({
  activeFilter,
  onFilterChange,
}) => {
  return (
    <div className={styles.filters}>
      {FILTER_OPTIONS.map((option) => (
        <button
          key={option.value}
          className={`${styles.filterBtn} ${activeFilter === option.value ? styles.active : ''}`}
          onClick={() => onFilterChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
